'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUERY_SELECTORS = exports.CLASS_NAMES = undefined;

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAMES = exports.CLASS_NAMES = {
  PRESENTATION: 'ironpt__presentation',
  SCALE: 'ironpt__scale',
  SCALE_CONTENT: 'ironpt__scale__content',
  SLIDES: 'ironpt__slides',
  SLIDE: 'ironpt__slide',
  SLIDE_INDEX: 'ironpt__slide-index',
  COVER: 'ironpt__cover',
  H1: 'ironpt__h1',
  H2: 'ironpt__h2',
  P: 'ironpt__p',
  UL: 'ironpt__ul',
  LI: 'ironpt__li',
  CODE: 'ironpt__code'
};

var QUERY_SELECTORS = exports.QUERY_SELECTORS = _fp2.default.mapValues(function (className) {
  return '.' + className;
})(CLASS_NAMES);


/*****************
 ** WEBPACK FOOTER
 ** ../lib/constants.js
 ** module id = 7
 ** module chunks = 0
 **/